// THIS FILE WAS AUTOGENERATED BY SVGR. DO NOT MODIFY IT MANUALLY;
import { Ref, SVGProps, forwardRef, memo } from 'react'

const SvgLogoTelegramMonochrome = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M3.375 11.15c5.369-2.339 8.949-3.88 10.74-4.626 5.114-2.127 6.177-2.497 6.87-2.51.152-.002.493.036.713.215.186.151.238.356.262.499.025.143.055.47.031.725-.277 2.912-1.476 9.979-2.086 13.24-.259 1.38-.767 1.843-1.259 1.888-1.07.099-1.881-.706-2.917-1.386-1.621-1.062-2.537-1.723-4.11-2.76-1.818-1.198-.64-1.857.396-2.933.272-.282 4.984-4.568 5.075-4.957.011-.048.022-.23-.086-.325-.108-.096-.266-.063-.381-.037-.163.037-2.752 1.748-7.768 5.134-.735.505-1.4.75-1.997.738-.658-.014-1.923-.372-2.863-.678-1.153-.374-2.07-.573-1.99-1.21.041-.331.498-.67 1.37-1.017Z"
      fill="#fff"
    />
  </svg>
))
SvgLogoTelegramMonochrome.displayName = 'SvgLogoTelegramMonochrome'
const Memo = memo(SvgLogoTelegramMonochrome)
export { Memo as SvgLogoTelegramMonochrome }
